import { useTranslation } from 'react-i18next';

import { AscendProgramHelpTrigger } from './AscendProgramHelp';

const BASE_URL = import.meta.env.VITE_BASE_URL;

type Props = {
  partnerLevel: number;
  partnerLevelTitle: string;
};

export function AscendPartnerLevel({ partnerLevel, partnerLevelTitle }: Props) {
  const { t } = useTranslation();

  if (partnerLevel === 0) {
    return null;
  }

  return (
    <AscendProgramHelpTrigger className="w-full h-full">
      <div className="relative w-full h-full">
        <PartnerIcon level={partnerLevel} className="w-full h-full" />
        <span>
          {t(`${partnerLevelTitle} Partner`, {
            defaultValue: {
              'CC': 'Certified Clinic',
              'AC': 'Advanced Center',
              'CE': 'Center of Excellence',
            }[partnerLevelTitle],
          })}
        </span>
        <span className="absolute top-[-4px] right-[-12px]">
          <HelpIcon />
        </span>
      </div>
    </AscendProgramHelpTrigger>
  );
}

function HelpIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_41_358)">
        <path
          d="M6.5 0C8.29486 0 9.92012 0.727695 11.0962 1.90379C12.2723 3.08014 13 4.70514 13 6.5C13 8.29486 12.2723 9.92012 11.0962 11.0962C9.92012 12.2723 8.29486 13 6.5 13C4.70514 13 3.08014 12.2723 1.90379 11.0962C0.727695 9.92012 0 8.29486 0 6.5C0 4.70514 0.727695 3.08014 1.90379 1.90379C3.08014 0.727695 4.70514 0 6.5 0ZM5.95436 7.65553V7.60398C5.95842 7.26223 5.99193 6.99156 6.0577 6.79021C6.12219 6.58912 6.21486 6.42535 6.33623 6.30145C6.45734 6.17652 6.60309 6.06303 6.77346 5.95969C6.88289 5.89012 6.98217 5.81293 7.07002 5.7266C7.15762 5.64129 7.22719 5.54201 7.27898 5.42979C7.33027 5.31883 7.35617 5.19518 7.35617 5.05857C7.35617 4.89607 7.31758 4.75541 7.24014 4.63557C7.16396 4.51674 7.06088 4.42533 6.93443 4.35957C6.80672 4.29508 6.66504 4.26283 6.50889 4.26283C6.36848 4.26283 6.23441 4.29102 6.10543 4.35043C5.97772 4.40857 5.87057 4.49998 5.78678 4.62389C5.70299 4.74754 5.65398 4.90623 5.64104 5.09971H4.80543C4.81838 4.7709 4.90217 4.49236 5.05553 4.2641C5.21041 4.03584 5.4143 3.86293 5.66693 3.74563C5.92109 3.62832 6.20217 3.57043 6.50889 3.57043C6.84684 3.57043 7.14086 3.63213 7.3935 3.75857C7.64639 3.88375 7.84367 4.05895 7.98434 4.2834C8.12348 4.50785 8.19457 4.76836 8.19457 5.06746C8.19457 5.27262 8.16232 5.45695 8.09783 5.62072C8.03334 5.78449 7.94295 5.9315 7.82438 6.05922C7.70555 6.1882 7.56514 6.30145 7.4001 6.39971C7.24395 6.49771 7.11775 6.59826 7.02229 6.70262C6.92555 6.80697 6.85572 6.93088 6.81205 7.07281C6.76813 7.21576 6.74375 7.39248 6.73994 7.60398V7.65553H5.95436ZM6.36975 9.32674C6.21893 9.32572 6.08994 9.27266 5.98152 9.16551C5.87336 9.05861 5.82029 8.92836 5.82029 8.77627C5.82029 8.62672 5.87336 8.49773 5.98152 8.39059C6.08994 8.28369 6.21893 8.22935 6.36975 8.22935C6.51803 8.22935 6.64701 8.28369 6.75518 8.39059C6.86486 8.49773 6.91895 8.62672 6.91895 8.77627C6.91895 8.87682 6.8933 8.96975 6.84303 9.05227C6.79275 9.13605 6.72699 9.20309 6.64447 9.25209C6.56195 9.30109 6.47029 9.32572 6.36975 9.32674ZM10.6059 2.39408C9.55525 1.34367 8.10342 0.693672 6.5 0.693672C4.89658 0.693672 3.445 1.34367 2.39408 2.39408C1.34367 3.445 0.693672 4.89658 0.693672 6.5C0.693672 8.10342 1.34367 9.55525 2.39408 10.6059C3.445 11.6563 4.89658 12.3063 6.5 12.3063C8.10342 12.3063 9.55525 11.6563 10.6059 10.6059C11.6563 9.55525 12.3063 8.10342 12.3063 6.5C12.3063 4.89658 11.6563 3.445 10.6059 2.39408Z"
          fill="#A1A1A1"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_358">
          <rect width="13" height="13" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PartnerIcon({ level, className }: { level: number; className?: string }) {
  switch (level) {
    case 1:
      return (
        <img
          src={`${BASE_URL}/assets/images/badge-certified-clinic-small.png`}
          alt="Certified Clinic"
          width={31}
          height={31}
          className={className}
        />
      );

    case 2:
      return (
        <img
          src={`${BASE_URL}/assets/images/badge-advanced-center-small.png`}
          alt="Advanced Clinic"
          width={31}
          height={31}
          className={className}
        />
      );

    case 3:
      return (
        <img
          src={`${BASE_URL}/assets/images/badge-center-excellence-small.png`}
          alt="Center of Excellence"
          width={31}
          height={31}
          className={className}
        />
      );

    default:
      return null;
  }
}
